import { useTheme } from 'foundations-theming/utils';
import { memo, useCallback } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { OLAF, CALYPSO_DARK } from 'HubStyleTokens/colors';
import { EARTH_LAYER } from 'HubStyleTokens/sizes';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import useButtonA11yProps from 'collaboration-sidebar/hooks/useButtonA11yProps';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../../../images/... Remove this comment to see the full error message
import CommentIndicatorPointer from 'bender-url!../../../../images/CommentIndicatorPointer.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../../../images/... Remove this comment to see the full error message
import CommentIndicatorPointerFlint from 'bender-url!../../../../images/CommentIndicatorPointerFlint.svg';
import useUnreadRepliesCount from '../hooks/useUnreadRepliesCount';
import UINotificationBadge from 'UIComponents/badge/UINotificationBadge';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const HoverableIconCircle = styled(UIIconCircle).withConfig({
  displayName: "EmbeddedCommentIndicator__HoverableIconCircle",
  componentId: "cueb83-0"
})([".hs-private.hs-private.hs-private &{z-index:", ";opacity:0;animation:0.1s ", " 0s 1 ease-out forwards;transition:box-shadow ease-out 150ms;pointer-events:all;}.hs-private.hs-private.hs-private ", " &:hover{cursor:pointer;", "}"], EARTH_LAYER, fadeIn, ({
  borderColor
}) => borderColor && `border-color: ${borderColor};`, ({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'boxShadow' does not exist on type 'UIIco... Remove this comment to see the full error message
  boxShadow
}) => boxShadow && `box-shadow: 0 0 0 1px ${CALYPSO_DARK}, 0 0 8px 0 ${CALYPSO_DARK};`);
const SharedIconPointerStyled = css(["z-index:", ";position:absolute;height:27px;"],
// @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
EARTH_LAYER - 1);
const HorizontalIconPointer = styled.img.attrs({
  ['data-test-id']: 'horizontal-pointer'
}).withConfig({
  displayName: "EmbeddedCommentIndicator__HorizontalIconPointer",
  componentId: "cueb83-1"
})([".hs-private.hs-private.hs-private &{", " margin-left:-20px;}.hs-private.hs-private.hs-private &:hover{cursor:pointer;}"], SharedIconPointerStyled);
const VerticalIconPointer = styled.img.attrs({
  ['data-test-id']: 'vertical-pointer'
}).withConfig({
  displayName: "EmbeddedCommentIndicator__VerticalIconPointer",
  componentId: "cueb83-2"
})([".hs-private.hs-private.hs-private &{", " transform:rotate(90deg);margin-left:-25px;margin-top:6px;}.hs-private.hs-private.hs-private &:hover{cursor:pointer;}"], SharedIconPointerStyled);
const StyledUINotificationBadge = styled(UINotificationBadge).withConfig({
  displayName: "EmbeddedCommentIndicator__StyledUINotificationBadge",
  componentId: "cueb83-3"
})([".hs-private.hs-private.hs-private & .unread-comments-badge{z-index:", ";transform:translateX(-2px);box-sizing:border-box;}.hs-private.hs-private.hs-private & .sr-only{position:absolute !important;width:1px !important;height:1px !important;margin:-1px !important;padding:0 !important;overflow:hidden !important;clip:rect(0,0,0,0) !important;border:0 !important;}"], EARTH_LAYER);
function EmbeddedCommentIndicator({
  collaborationSidebarState,
  isOpen,
  onClose,
  iconProps,
  setIsCommenting,
  verticalPositioning,
  hasCustomPosition,
  moduleParentComment,
  embeddedCommentWrapperRef,
  toggleOpenPopover
}) {
  const trellisTheme = useTheme();
  const {
    unreadCommentsCount
  } = useUnreadRepliesCount({
    collaborationSidebarState,
    moduleParentComment
  });
  const onIconClick = useCallback(e => {
    if (isOpen && onClose) {
      onClose();
    } else {
      toggleOpenPopover(true);
      setIsCommenting(true);
      // Prevent the outside click event from closing the popover
      e.stopPropagation();
    }
  }, [isOpen, onClose, setIsCommenting, toggleOpenPopover]);
  const IconPointer = verticalPositioning ? VerticalIconPointer : HorizontalIconPointer;
  const buttonA11yProps = useButtonA11yProps({
    i18nKey: 'collaborationSidebar.modals.commentMode.viewComments',
    onClick: onIconClick
  });
  const isParentResolved = moduleParentComment === null || moduleParentComment === void 0 ? void 0 : moduleParentComment.resolved;
  const hoverableCircleBackgroundColor = isParentResolved ? trellisTheme.color['do-not-use-flint'] : trellisTheme.color['do-not-use-lorax'];
  const ColouredCommentIndicatorPointer = isParentResolved ? CommentIndicatorPointerFlint : CommentIndicatorPointer;
  return /*#__PURE__*/_jsxs("div", {
    ref: embeddedCommentWrapperRef,
    children: [/*#__PURE__*/_jsx(StyledUINotificationBadge, {
      badgeLabel: unreadCommentsCount,
      badgeDescription: I18n.text('collaborationSidebar.modals.commentMode.newComments'),
      badgeClassName: "unread-comments-badge",
      showBadge: unreadCommentsCount > 0,
      children: /*#__PURE__*/_jsx(HoverableIconCircle, Object.assign({
        name: "comments",
        id: "comment-indicator",
        "data-test-id": "comment-indicator",
        iconClassName: "comment-indicator",
        onClick: onIconClick,
        color: OLAF,
        backgroundColor: hoverableCircleBackgroundColor,
        borderWidth: 0,
        size: 10
      }, buttonA11yProps, iconProps))
    }), !hasCustomPosition && /*#__PURE__*/_jsx(IconPointer, {
      id: "comment-indicator",
      onClick: onIconClick,
      src: ColouredCommentIndicatorPointer
    })]
  });
}
export default /*#__PURE__*/memo(EmbeddedCommentIndicator);